"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizerUser = exports.DirectorUser = void 0;
class DirectorUser {
    constructor({ id, name, email, profileImageUrl, }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            email: this.email,
            profileImageUrl: this.profileImageUrl,
        });
        this.id = id;
        this.name = name;
        this.email = email;
        this.profileImageUrl = profileImageUrl;
    }
}
exports.DirectorUser = DirectorUser;
DirectorUser.fromJSON = (json) => {
    const { id, name, email, profileImageUrl } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (name !== undefined && typeof name !== 'string')
        throw new Error('.name must be a string');
    if (profileImageUrl !== undefined && typeof profileImageUrl !== 'string')
        throw new Error('.profileImageUrl must be a string');
    return new DirectorUser({ id, name, email, profileImageUrl });
};
class OptimizerUser {
    constructor({ id, name, email, profileImageUrl, }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            email: this.email,
            profileImageUrl: this.profileImageUrl,
        });
        this.id = id;
        this.name = name;
        this.email = email;
        this.profileImageUrl = profileImageUrl;
    }
}
exports.OptimizerUser = OptimizerUser;
OptimizerUser.fromJSON = (json) => {
    const { id, name, email, profileImageUrl } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (name !== undefined && typeof name !== 'string')
        throw new Error('.name must be a string');
    if (profileImageUrl !== undefined && typeof profileImageUrl !== 'string')
        throw new Error('.profileImageUrl must be a string');
    return new OptimizerUser({ id, name, email, profileImageUrl });
};
